import { inject, PLATFORM_ID } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { AdminService } from "@malirang/api-client";
import { ADMIN_ACCESS_TOKEN_KEY } from "@malirang/common";
import { LocalStorageService } from "@malirang/front-share";
import { lastValueFrom } from "rxjs";
import { AdminStore } from "../stores/admin.store";
import { isPlatformServer } from "@angular/common";

export const AuthGuard: CanActivateFn = (route, state) => {
    return new Promise<boolean>(async (resolve) => {
        const platformId = inject(PLATFORM_ID);
        const isServer = isPlatformServer(platformId);
        if (isServer) {
            resolve(true);
            return;
        }
        const localStorageService = inject(LocalStorageService);
        const adminService = inject(AdminService);
        const adminStore = inject(AdminStore);
        const router = inject(Router);

        const accessToken = await localStorageService.get(
            ADMIN_ACCESS_TOKEN_KEY,
        );

        if (!accessToken) {
            router.navigate(["/login"]);
            resolve(false);
            return;
        }

        try {
            const admin = await lastValueFrom(adminService.adminControllerMe());
            adminStore.setAdmin(admin);
        } catch (error) {
            router.navigate(["/login"]);
            resolve(false);
            return;
        }

        resolve(true);
    });
};
